import { required, emailError } from '../utils/form-feedback';
import FormFeedback from '../components/FormFeedback';
import { useFormFeedback } from '../hooks/useFormFeedback';
import { Alert, Card, InputLabel, Snackbar, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useInviteUser } from '../api-client/hooks/useInviteUser';
import FilledButton from '../components/buttons/FilledButton';

export default function AddAdminPage() {
  const feedback = useFormFeedback();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const { mutateAsync: inviteUser } = useInviteUser();

  const handleAdd = async () => {
    if (!feedback.validate({ name: required(name, 'Name'), email: emailError(email) })) return;
    await feedback.execute(async () => {
      await inviteUser({ createUserParams: { email: email.trim(), name: name.trim() } });
      setOpen(true);
      setName('');
      setEmail('');
    });
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          User successfully invited!
        </Alert>
      </Snackbar>
      <Card sx={{ width: 600, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="body2">
          <InputLabel sx={{ marginBottom: 4 }}>
            Enter the info below to give a user access to the admin portal.
          </InputLabel>
        </Typography>
        <TextField
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{ width: 300, marginBottom: 4 }}
          variant="outlined"
          label="Name"
          required
          {...feedback.fieldProps('name')}
        />
        <TextField
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ width: 300 }}
          variant="outlined"
          label="Email"
          required
          {...feedback.fieldProps('email')}
        />
        <FormFeedback message={feedback.message} errors={feedback.errors} />
        <FilledButton disabled={feedback.busy} onClick={handleAdd} style={{ marginTop: 48 }}>
          Add Admin
        </FilledButton>
      </Card>
    </div>
  );
}
